<template>
   <div class="flex-container">
      <div class="left-container">
         <div class="row-item">
            <div  class="cell-item" >{{$t('barcode_shipping')}}</div>
            <div  class="cell-item">{{sharingSettingsData.open_api_barcodeshipping_detials.endpoint}}</div>
         </div>
         <div class="row-item">
            <div  class="cell-item" >{{$t('json_orders_import')}}</div>
            <div  class="cell-item">{{sharingSettingsData.open_api_json_orders_import_detials.endpoint}}</div>
         </div>
         <div class="row-item">
            <div  class="cell-item">{{$t('label_json_import')}}</div>
            <div style="display: flex;flex-direction: column;" class="cell-item">
               <div>
                  {{sharingSettingsData.open_api_json_import_label_detials.endpoint }}
               </div>
               <div>
                  {{`{ api_key:${sharingSettingsData.open_api_json_import_label_detials.checksum} clientID:${sharingSettingsData.open_api_json_import_label_detials.clientID} }` }}
               </div>
            </div>
         </div>
         <!-- +clientName+"/?action=products&api_key="+sharingSettingsData.ext_api_checksum -->
      </div>
   </div>
</template>
<script>
import { MHTTPCL} from "../../../../services/http/http-client";
import TextField from '@plugins/text-field/text-field';
   export default {
      props:["sharingSettingsData","clientName"],
      computed:{
         
         baseUrl:function(){
            return MHTTPCL.getBaseUrl()
         }
      },
      data:function(){
         return{
            stock:"&product_uuids=<product_UUID>&account_ids=<account_id|account_id|...>",
            addOrder:"<any field of our database l_orders table>=<value>&<any field of our database contacts table>=<value>&orderLines=<UUID_of_product>|<order_qty>|<ppu>|<status>&orderLines=<UUID_of_product>|<order_qty>|<ppu>|<status>",
             bookingForm:"booking",
         }
      } 
   }
</script>
<style scoped>
   .flex-container
   {
      display: flex;
      flex-direction: column;
   }
   .row-item
   {
      padding: 0.5em;
      border-bottom:1px solid #ccc;
      display: flex;
      flex-direction: row;
   /* height: 40px; */
   }
   .cell-item
   {
      /* padding:0.5em; */
      text-overflow: ellipsis;
      overflow: hidden;
      /* white-space: nowrap; */
   }
   .cell-item:first-child {
       min-width: 20%;
       max-width: 20%;
    }
     .cell-item:nth-child(2) {
      text-align: left;
      word-break: break-all;
   }

   .text-field
   {
      border: 1px solid #bbbaba;
      padding: 5px;
      border-radius:5px ;
      width: 100%;
   }
   .text-field:focus {
      border: 1px solid #bbbaba;
 
   }
</style>